import { JiraServiceManagementLogo } from '@atlaskit/logo';

import { defineContent, type DefinedContent } from '@post-office/define-content';

import { FormattedMessage, defineMessage } from 'react-intl';

import { type JSX } from 'react/jsx-runtime';

export const CCP_PRODUCT_ID = 'de63a248-1f93-46ed-b6ea-ab8e38af1c88';

export const HAMS_PRODUCT_ID = 'jira-servicedesk.ondemand';

export const PRODUCT_NAME = 'Jira Service Management';

export const registeredContent: DefinedContent<{
	default: ['appName', 'description'];
	template: ['appName', 'description'];
}> = defineContent({
	default: {
		appName: {
			id: 'growth.recommendation-jsm.app-switcher-discovery-section.app-name',
			defaultMessage: 'Jira Service Management',
			description:
				'Product name for the Jira Service Management recommendation in the app switcher discovery section',
			role: 'title',
		},
		description: {
			id: 'growth.recommendation-jsm.value-proposition',
			description: 'Description of the product value proposition',
			defaultMessage: 'Collaborative IT service management',
			role: 'description',
		},
	},
	template: {
		appName: {
			id: 'growth.recommendation-jsm.app-switcher-discovery-section.template-name',
			defaultMessage: 'Work requests',
			description:
				'Template name for the Jira Service Management work requests recommendation in the app switcher discovery section',
			role: 'title',
		},
		description: {
			id: 'growth.recommendation-jsm-work-request.value-proposition',
			description: 'Description of the product value proposition',
			defaultMessage: 'Create one place to manage requests',
			role: 'description',
		},
	},
});

export const PRODUCT_DESCRIPTION: JSX.Element = (
	<FormattedMessage {...registeredContent.default.description} />
);

// go/trailblazers
// TBLZ-858 Product Store - Personal Use Case
export const PRODUCT_LOGO_COMPONENT: JSX.Element = (
	<JiraServiceManagementLogo appearance={'brand'} />
);

export const PRODUCT_HEADING: JSX.Element = (
	<FormattedMessage
		id="growth.recommendation-jsm.product-heading"
		description="Description of the product"
		defaultMessage="Make your work more visible"
	/>
);

export const PRODUCT_SUBHEADING: JSX.Element = (
	<FormattedMessage
		id="growth.recommendation-jsm.product-subheading"
		description="Extra information about the product"
		defaultMessage="Connect Dev and Ops teams on a single platform to collaborate and connect the whole picture, from request to resolution."
	/>
);

export const PRODUCT_IMAGE_ALT_TEXT: {
	id: string;
	description: string;
	defaultMessage: string;
} = defineMessage({
	id: 'growth.recommendation-jsm.product-alt-text',
	description: 'Alt text for the product image',
	defaultMessage:
		'Seven requests are all organized in one place, with a status and project connected to each request.',
});

// Template-specific constants
export const JSM_TEMPLATE_GENERAL_SERVICE_MANAGEMENT = 'jsm.general-service-management';

export const JSM_TEMPLATE_SELECTOR_KEY_WORK_REQUESTS = 'productRequests';

export const JSM_TEMPLATE_WORK_REQUESTS_NAME = 'Work requests';

export const JSM_TEMPLATE_WORK_REQUESTS_DESCRIPTION: JSX.Element = (
	<FormattedMessage {...registeredContent.template.description} />
);
